import request from '@utils/request'
import { groupById } from '@utils/normalize-data'

export const state = {
  cached: [],
  byId: {},
}

export const getters = {}

export const mutations = {
  CACHE_PRODUCTS(state, currentProducts) {
    state.cached = currentProducts
    state.byId = groupById(currentProducts, 'products')
  },
}

export const actions = {
  fetchPrices({ commit }, { productId, query }) {
    return request
      .post(`/admin/product/${productId}/price/search`, {
        paginate: 0,
        ...query,
      })
      .then((response) => response.items)
  },
  storePrices({ commit }, { productId, storeData, inventoryId = undefined }) {
    return request.post(`/admin/product/${productId}/price/store`, {
      inventoryId,
      params: storeData,
    })
  },
  inventoryCalendar({ commit }, { productId, submitData }) {
    return request.post(`/admin/product/${productId}/calendar`, submitData)
  },
  store({ commit }, storeData) {
    return request.post('/admin/product/store', storeData).then((response) => response && response.items)
  },
  updateState({ commit }, { ids, state } = {}) {
    return request.post('/admin/product/state', { ids, state })
  },
  remove({ commit }, { ids }) {
    return request.post('/admin/product/remove', { ids })
  },
  fetchSingle({ commit }, productId) {
    return request.get(`/admin/product/${productId}`).then((response) => response.items)
  },
  fetchList({ commit }, query) {
    return request.post('/admin/product/search', query).then(({ items, modulesLimit, modulesUsed, pagination: { total } }) => {
      commit('CACHE_PRODUCTS', items)
      return {
        items,
        modulesLimit,
        modulesUsed,
        total,
      }
    })
  },
  updateExtraField({ commit }, submitData) {
    return request.post(`/admin/product/order/extrafield/store`, submitData).then((response) => response.items)
  },
  fetchExtraField({ commit }, query) {
    return request.post('/admin/product/order/extrafield/search', query).then((response) => response.items)
  },
  // 燈種
  fetchLight({ commit }, productId) {
    return request
      .post(`admin/product/${productId}/priceitem/search`, { paginate: 0 })
      .then((response) => response.items)
  },
  storeLight({ commit }, { submitData, productId }) {
    return request.post(`/admin/product/${productId}/priceitem/store`, submitData)
  },
  sortLight({ commit }, { submitData, productId }) {
    return request.post(`/admin/product/${productId}/priceitem/ordering`, submitData)
  },
}
